import type { Surface } from './types';

/** Unity MaterialBuiltinStorage.DefaultFloor / Textures/floor/wood/wood.xml, Id="default". */
export function defaultFloorSurface(): Surface {
  return { textureKind: 'catalog', texture: 'floor/wood/parquet_07_01.jpg',
    // i18n-ignore: the caption is stored in the project, a default of the file contract; the app stores "Parquet". Left for the owner.
    tileMeters: [3.24, 3.24], shininess: 0.4, caption: 'Паркет' };
}

/** Locales the native app measures in inches (Unity GuiUtils.UseInches follows the region). */
const INCH_CULTURES = ['en-us', 'en-lr', 'my-mm'];
export function usesInches(culture: string | undefined): boolean {
  return INCH_CULTURES.includes((culture ?? '').toLowerCase());
}

/**
 * Unity ModelSettings.DefaultWallThickness: 0.2 m, and in inch-based locales the same value
 * rounded to whole inches (8″ = 0.2032 m). The plan stays metric on screen; the locale only
 * chooses the value a drawn wall starts with.
 */
export function defaultWallThickness(culture?: string): number {
  return usesInches(culture) ? Math.round(0.2 / 0.0254) * 0.0254 : 0.2;
}

/** The ladder the thickness control walks: Lite's options widened up to Unity's one-metre ceiling. */
export const WALL_THICKNESS_STEPS = [0.05, 0.08, 0.1, 0.12, 0.15, 0.2, 0.25, 0.3, 0.4, 0.5, 0.6, 0.8, 1] as const;
export const WALL_THICKNESS_RANGE = { min: 0.03, max: 1 } as const;

export function stepWallThickness(value: number, direction: 1 | -1): number {
  const ladder = WALL_THICKNESS_STEPS;
  if (direction > 0) return ladder.find(step => step > value + 1e-6) ?? ladder[ladder.length - 1];
  return [...ladder].reverse().find(step => step < value - 1e-6) ?? ladder[0];
}

export function clampWallThickness(value: number): number {
  if (!Number.isFinite(value)) return 0.2;
  return Math.round(Math.min(WALL_THICKNESS_RANGE.max, Math.max(WALL_THICKNESS_RANGE.min, value)) * 1000) / 1000;
}
